module.exports = __webpack_public_path__ + "img/5ws.8ba893f7.png";